import React from "react";
import { Row, Col, Card, Spinner } from "react-bootstrap";
import { FaUsers, FaMoneyBillWave } from "react-icons/fa";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import {
  GOLD_PACKAGE,
  SILVER_PACKAGE,
  BRONZE_PACKAGE,
} from "../../../backend/PAYMENT_PACKAGES_CONSTANTS";

const HomeTab = ({
  userStats,
  users,
  loginStats,
  loginStatsLoading,
  dailyStats,
  dailyStatsLoading,
  handlePackageClick,
}) => {
  return (
    <>
      <div className="pane-header">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h2 className="pane-title">
              ברוכים הבאים לדשבורד השליטה ב SimplyCoach
            </h2>
            <p className="pane-subtitle">ניהול המערכת המרכזי</p>
          </div>
        </div>
      </div>
      <Row className="super-dashboard-mt-4">
        <Col md={4}>
          <Card className="super-dashboard-stats-card">
            <Card.Body className="super-dashboard-card-body">
              <div className="d-flex align-items-center">
                <FaUsers className="super-dashboard-stats-icon" size={40} />
                <div className="ms-4">
                  <h5 className="mb-1 text-muted">משתמשים פעילים</h5>
                  <h2 className="mb-0 fw-bold">
                    {userStats.activeUsers.toLocaleString()}
                  </h2>
                  <small className="text-muted">ב-3 ימים האחרונים</small>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="super-dashboard-stats-card">
            <Card.Body className="super-dashboard-card-body">
              <div className="d-flex align-items-center">
                <FaMoneyBillWave
                  className="super-dashboard-stats-icon"
                  size={40}
                />
                <div className="ms-4">
                  <h5 className="mb-1 text-muted">הכנסה משוערת</h5>
                  <h2 className="mb-0 fw-bold">
                    ₪{userStats.estimatedRevenue.toLocaleString()}
                  </h2>
                  <small className="text-muted">חודשי</small>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="super-dashboard-stats-card">
            <Card.Body className="super-dashboard-card-body">
              <div className="d-flex align-items-center">
                <FaUsers className="super-dashboard-stats-icon" size={40} />
                <div className="ms-4">
                  <h5 className="mb-1 text-muted">סה"כ משתמשים</h5>
                  <h2 className="mb-0 fw-bold">
                    {users.length.toLocaleString()}
                  </h2>
                  <small className="text-muted">במערכת</small>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row className="super-dashboard-mt-4">
        <Col md={4}>
          <Card
            className="super-dashboard-stats-card super-dashboard-gold-card"
            onClick={() => handlePackageClick("gold")}
            style={{ cursor: "pointer" }}
          >
            <Card.Body className="super-dashboard-card-body">
              <div className="d-flex align-items-center">
                <div className="super-dashboard-stats-icon">
                  <span className="super-dashboard-package-icon">G</span>
                </div>
                <div className="ms-4">
                  <h5 className="mb-1 text-muted">משתמשי חבילת זהב</h5>
                  <h2 className="mb-0 fw-bold">
                    {userStats.goldUsers.toLocaleString()}
                  </h2>
                  <small className="text-muted">
                    ₪{GOLD_PACKAGE.PRICE.toLocaleString()} לחודש
                  </small>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card
            className="super-dashboard-stats-card super-dashboard-silver-card"
            onClick={() => handlePackageClick("silver")}
            style={{ cursor: "pointer" }}
          >
            <Card.Body className="super-dashboard-card-body">
              <div className="d-flex align-items-center">
                <div className="super-dashboard-stats-icon">
                  <span className="super-dashboard-package-icon">S</span>
                </div>
                <div className="ms-4">
                  <h5 className="mb-1 text-muted">משתמשי חבילת כסף</h5>
                  <h2 className="mb-0 fw-bold">
                    {userStats.silverUsers.toLocaleString()}
                  </h2>
                  <small className="text-muted">
                    ₪{SILVER_PACKAGE.PRICE.toLocaleString()} לחודש
                  </small>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card
            className="super-dashboard-stats-card super-dashboard-bronze-card"
            onClick={() => handlePackageClick("bronze")}
            style={{ cursor: "pointer" }}
          >
            <Card.Body className="super-dashboard-card-body">
              <div className="d-flex align-items-center">
                <div className="super-dashboard-stats-icon">
                  <span className="super-dashboard-package-icon">B</span>
                </div>
                <div className="ms-4">
                  <h5 className="mb-1 text-muted">משתמשי חבילת ארד</h5>
                  <h2 className="mb-0 fw-bold">
                    {userStats.bronzeUsers.toLocaleString()}
                  </h2>
                  <small className="text-muted">
                    ₪{BRONZE_PACKAGE.PRICE.toLocaleString()} לחודש
                  </small>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Login Statistics Section */}
      <div className="login-stats-section">
        <Row>
          <Col xs={12}>
            <h3 className="login-stats-title">סטטיסטיקות התחברות</h3>
          </Col>
        </Row>

        {/* Mobile Login Stats Section */}
        <div className="stats-subsection mobile-stats">
          <Row>
            <Col xs={12}>
              <h4 className="subsection-title">
                <span className="subsection-icon">📱</span>
                התחברות לאפליקציית ה-MOBILE
              </h4>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Card className="super-dashboard-stats-card super-dashboard-mobile-card">
                <Card.Body className="super-dashboard-card-body">
                  <div className="d-flex align-items-center">
                    <div className="super-dashboard-stats-icon">
                      <span className="super-dashboard-mobile-icon">📱</span>
                    </div>
                    <div className="ms-3">
                      <h5 className="mb-1 text-muted">24 שעות אחרונות</h5>
                      <h2 className="mb-0 fw-bold">
                        {loginStatsLoading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          loginStats.mobile.last24h.toLocaleString()
                        )}
                      </h2>
                      <small className="text-muted">משתמשים</small>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="super-dashboard-stats-card super-dashboard-mobile-card">
                <Card.Body className="super-dashboard-card-body">
                  <div className="d-flex align-items-center">
                    <div className="super-dashboard-stats-icon">
                      <span className="super-dashboard-mobile-icon">📱</span>
                    </div>
                    <div className="ms-3">
                      <h5 className="mb-1 text-muted">3 ימים אחרונים</h5>
                      <h2 className="mb-0 fw-bold">
                        {loginStatsLoading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          loginStats.mobile.last3d.toLocaleString()
                        )}
                      </h2>
                      <small className="text-muted">משתמשים</small>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="super-dashboard-stats-card super-dashboard-mobile-card">
                <Card.Body className="super-dashboard-card-body">
                  <div className="d-flex align-items-center">
                    <div className="super-dashboard-stats-icon">
                      <span className="super-dashboard-mobile-icon">📱</span>
                    </div>
                    <div className="ms-3">
                      <h5 className="mb-1 text-muted">7 ימים אחרונים</h5>
                      <h2 className="mb-0 fw-bold">
                        {loginStatsLoading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          loginStats.mobile.last7d.toLocaleString()
                        )}
                      </h2>
                      <small className="text-muted">משתמשים</small>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>

        {/* Web Login Stats Section */}
        <div className="stats-subsection web-stats">
          <Row>
            <Col xs={12}>
              <h4 className="subsection-title">
                <span className="subsection-icon">💻</span>
                התחברות לאפליקציית ה-WEB
              </h4>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Card className="super-dashboard-stats-card super-dashboard-web-card">
                <Card.Body className="super-dashboard-card-body">
                  <div className="d-flex align-items-center">
                    <div className="super-dashboard-stats-icon">
                      <span className="super-dashboard-web-icon">💻</span>
                    </div>
                    <div className="ms-3">
                      <h5 className="mb-1 text-muted">24 שעות אחרונות</h5>
                      <h2 className="mb-0 fw-bold">
                        {loginStatsLoading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          loginStats.web.last24h.toLocaleString()
                        )}
                      </h2>
                      <small className="text-muted">משתמשים</small>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="super-dashboard-stats-card super-dashboard-web-card">
                <Card.Body className="super-dashboard-card-body">
                  <div className="d-flex align-items-center">
                    <div className="super-dashboard-stats-icon">
                      <span className="super-dashboard-web-icon">💻</span>
                    </div>
                    <div className="ms-3">
                      <h5 className="mb-1 text-muted">3 ימים אחרונים</h5>
                      <h2 className="mb-0 fw-bold">
                        {loginStatsLoading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          loginStats.web.last3d.toLocaleString()
                        )}
                      </h2>
                      <small className="text-muted">משתמשים</small>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="super-dashboard-stats-card super-dashboard-web-card">
                <Card.Body className="super-dashboard-card-body">
                  <div className="d-flex align-items-center">
                    <div className="super-dashboard-stats-icon">
                      <span className="super-dashboard-web-icon">💻</span>
                    </div>
                    <div className="ms-3">
                      <h5 className="mb-1 text-muted">7 ימים אחרונים</h5>
                      <h2 className="mb-0 fw-bold">
                        {loginStatsLoading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          loginStats.web.last7d.toLocaleString()
                        )}
                      </h2>
                      <small className="text-muted">משתמשים</small>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>

        {/* Activity Comparison Chart */}
        <div className="stats-subsection chart-section">
          <Row>
            <Col xs={12}>
              <h4 className="subsection-title">
                <span className="subsection-icon">📊</span>
                השוואת פעילות - 7 ימים אחרונים
              </h4>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <div className="chart-container">
                {dailyStatsLoading ? (
                  <div className="text-center p-4">
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">טוען גרף...</span>
                    </Spinner>
                  </div>
                ) : dailyStats.length > 0 ? (
                  <ResponsiveContainer width="100%" height={300}>
                    <LineChart
                      data={dailyStats}
                      margin={{
                        top: 20,
                        right: 30,
                        left: 20,
                        bottom: 20,
                      }}
                    >
                      <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                      <XAxis
                        dataKey="dayName"
                        stroke="#64748b"
                        fontSize={12}
                        tickLine={false}
                        axisLine={false}
                      />
                      <YAxis
                        stroke="#64748b"
                        fontSize={12}
                        tickLine={false}
                        axisLine={false}
                        tickFormatter={(value) => value.toLocaleString()}
                      />
                      <Tooltip
                        contentStyle={{
                          backgroundColor: "rgba(255, 255, 255, 0.95)",
                          border: "1px solid #e2e8f0",
                          borderRadius: "8px",
                          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                        }}
                        labelStyle={{
                          color: "#475569",
                          fontWeight: "600",
                        }}
                        formatter={(value, name) => [
                          value.toLocaleString(),
                          name === "mobile"
                            ? "מובייל"
                            : name === "web"
                            ? "ווב"
                            : name,
                        ]}
                        labelFormatter={(label) => `יום: ${label}`}
                      />
                      <Legend
                        wrapperStyle={{
                          paddingTop: "10px",
                          fontSize: "12px",
                        }}
                        formatter={(value) =>
                          value === "mobile"
                            ? "מובייל"
                            : value === "web"
                            ? "ווב"
                            : value
                        }
                      />
                      <Line
                        type="monotone"
                        dataKey="mobile"
                        stroke="#86efac"
                        strokeWidth={3}
                        dot={{ fill: "#86efac", strokeWidth: 2, r: 4 }}
                        activeDot={{
                          r: 6,
                          stroke: "#4ade80",
                          strokeWidth: 2,
                        }}
                        name="mobile"
                      />
                      <Line
                        type="monotone"
                        dataKey="web"
                        stroke="#93c5fd"
                        strokeWidth={3}
                        dot={{ fill: "#93c5fd", strokeWidth: 2, r: 4 }}
                        activeDot={{
                          r: 6,
                          stroke: "#60a5fa",
                          strokeWidth: 2,
                        }}
                        name="web"
                      />
                    </LineChart>
                  </ResponsiveContainer>
                ) : (
                  <div className="text-center p-4">
                    <p className="text-muted">אין נתונים זמינים להצגה</p>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default HomeTab;
